import React, { createContext, useState, useContext } from 'react';

// Create Context
export const WizardContext = createContext();

// Create Provider
export const WizardProvider = ({ children }) => {
  // State variables from Step1.js
  const [selectionOption, setSelectionOption] = useState("Vegefest");

  // State variables from Step2.js
  const [firstname, setFirstname] = useState(null);
  const [lastname, setLastname] = useState(null);
  const [chinesename, setChinesename] = useState(null);
  const [gender, setGender] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [do3R5P, setDo3R5P] = useState(true);
  const [doLunch, setDoLunch] = useState(false);
  const [englishXlation, setEnglishXlation] = useState(false);
  const [cantoneseXlation, setCantoneseXlation] = useState(false);
  const [needShuttleBus, setNeedShuttleBus] = useState(false);
  const [isVolunteering, setIsVolunteering] = useState(false);
  const [relatives, setRelatives] = useState(null); 

  // State variables from Step3.js
  // Define them similarly...
  // Example:
  const [confirmation, setConfirmation] = useState(false);

  // Functions to validate or manage the steps, if needed, can be defined here too.
  const isValidatedStep1 = () => {
    return selectionOption !== null;
  };

  const isValidatedStep2 = () => {
    // Add your validation logic for Step2 here
    return true;
  };

  const isValidatedStep3 = () => {
    // Add your validation logic for Step3 here
    return true;
  };

  // Export all state variables and setters
  return (
    <WizardContext.Provider
      value={{
        selectionOption, setSelectionOption,
        firstname, setFirstname,
        lastname, setLastname,
        chinesename, setChinesename,
        gender, setGender,
        email, setEmail,
        phone, setPhone,
        do3R5P, setDo3R5P,
        doLunch, setDoLunch,
        confirmation, setConfirmation,
        englishXlation, setEnglishXlation,
        cantoneseXlation, setCantoneseXlation,
        needShuttleBus, setNeedShuttleBus,
        isVolunteering, setIsVolunteering,
        relatives,setRelatives,

      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

// Custom hook for using the Wizard Context
export const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard must be used within a WizardProvider');
  }
  return context;
};
